<script lang="ts" setup>
  import { computed } from 'vue'
  import { DELETE_EVENT_NAME, DEFAULT_TEXT, TEST_ID, VARIANT_CLASSES } from './BaseChip.constants'
  import type { ChipVariant } from './BaseChip.types'

  interface Props {
    text?: string
    isDeleteable?: boolean
    variant?: ChipVariant
    dataTest?: string
  }
  interface Emits {
    (e: typeof DELETE_EVENT_NAME): void
  }

  const props = withDefaults(defineProps<Props>(), {
    text: DEFAULT_TEXT,
    isDeleteable: false,
    variant: 'default',
    dataTest: TEST_ID,
  })

  const emit = defineEmits<Emits>()

  const onDelete = () => {
    emit(DELETE_EVENT_NAME)
  }
  const chipClass = computed(() => VARIANT_CLASSES[props.variant])
</script>

<template>
  <div :data-test="dataTest" class="chip" :class="chipClass">
    <span class="text">
      <slot> {{ text || DEFAULT_TEXT }} </slot>
    </span>
    <button
      v-if="isDeleteable"
      class="cross"
      type="button"
      :data-test="`${dataTest}-delete-button`"
      @click="onDelete"
    />
  </div>
</template>

<style lang="scss" scoped>
  @use './BaseChip';
</style>
